__turbopack_context__.v({
  "autocompleteContainer": "autocompleteInput-module-scss-module__uF3aIG__autocompleteContainer",
  "autocompleteResult": "autocompleteInput-module-scss-module__uF3aIG__autocompleteResult",
  "autocompleteResults": "autocompleteInput-module-scss-module__uF3aIG__autocompleteResults",
  "isActive": "autocompleteInput-module-scss-module__uF3aIG__isActive",
});
